import { SegmentMatch } from 'data/records'
import { resource, findSelector } from 'data/helpers/apiv3'
import { pascalCase } from 'lib/textUtils'

const [api, actions] = resource(SegmentMatch, [])

const selectors = {
  ...findSelector(SegmentMatch),
  segmentsForParent: (state, parentType, parentId) => (
    state.apiv3.segmentMatch.id.filter(
      s => s.parentType === pascalCase(parentType) && s.parentId === parentId
    )
  )
}

const reducers = {}

const initialState = {}

export {
  api as segmentMatchApi,
  actions as segmentMatchActions,
  selectors as segmentMatchSelectors,
  reducers as segmentMatchReducers,
  initialState as segmentMatchInitialState
}
